export default __webpack_public_path__ + "static/media/polk_button_diamond_line.11c44cf0.png";